const FETCH_CAMPAIGN_INFO = "campaign/FETCH_CAMPAIGN_INFO";
const FETCH_CAMPAIGN_INFO_SUCCESS = "campaign/FETCH_CAMPAIGN_INFO_SUCCESS";
const FETCH_CAMPAIGN_INFO_FAIL = "campaign/FETCH_CAMPAIGN_INFO_FAIL";

const FETCH_CLAIMED_CAMPAIGNS = "campaign/FETCH_CLAIMED_CAMPAIGNS";
const FETCH_CLAIMED_CAMPAIGNS_SUCCESS =
  "campaign/FETCH_CLAIMED_CAMPAIGNS_SUCCESS";
const FETCH_CLAIMED_CAMPAIGNS_FAIL = "campaign/FETCH_CLAIMED_CAMPAIGNS_FAIL";

const initialState = {
  pending: true,
  loaded: false,
  campaigns: {},
  claimed_campaigns: {},
  error: null
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_CAMPAIGN_INFO:
      return Object.assign({}, state, {
        pending: true,
        loaded: false
      });
    case FETCH_CAMPAIGN_INFO_SUCCESS:
      return Object.assign({}, state, {
        pending: false,
        loaded: true,
        campaigns: { ...action.results },
        error: null
      });
    case FETCH_CAMPAIGN_INFO_FAIL:
      return Object.assign({}, state, {
        pending: false,
        loaded: true,
        error: action.error
      });

    case FETCH_CLAIMED_CAMPAIGNS:
      return Object.assign({}, state, {
        pending: true,
        loaded: false
      });
    case FETCH_CLAIMED_CAMPAIGNS_SUCCESS:
      return Object.assign({}, state, {
        pending: false,
        loaded: true,
        claimed_campaigns: { ...action.results },
        error: null
      });
    case FETCH_CLAIMED_CAMPAIGNS_FAIL:
      return Object.assign({}, state, {
        pending: false,
        loaded: true,
        error: action.error
      });

    default:
      return state;
  }
}

export function fetchCampaignInfoPending() {
  return {
    type: FETCH_CAMPAIGN_INFO
  };
}

export function fetchCampaignInfoSuccess(results) {
  return {
    type: FETCH_CAMPAIGN_INFO_SUCCESS,
    results
  };
}

export function fetchCampaignInfoFail(error) {
  return {
    type: FETCH_CAMPAIGN_INFO_FAIL,
    error
  };
}

export function fetchClaimedCampaignsPending() {
  return {
    type: FETCH_CLAIMED_CAMPAIGNS
  };
}

export function fetchClaimedCampaignsSuccess(results) {
  return {
    type: FETCH_CLAIMED_CAMPAIGNS_SUCCESS,
    results
  };
}

export function fetchClaimedCampaignsFail(errors) {
  return {
    type: FETCH_CLAIMED_CAMPAIGNS_FAIL,
    errors
  };
}

export const getCampaigns = state => state.campaigns;
export const getClaimedCampaigns = state => state.campaigns;
export const getError = state => state.error;
export const getPending = state => state.pending;
export const getLoaded = state => state.loaded;
